document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-so-related-variant]');
  if (!select) return;

  const card = select.closest('.so-related-card');
  const option = select.selectedOptions[0];
  if (!card || !option) return;

  const currentPrice = card.querySelector('[data-so-related-current]');
  const comparePrice = card.querySelector('[data-so-related-compare]');
  const saving = card.querySelector('[data-so-related-saving]');
  const submit = card.querySelector('[data-so-related-submit]');
  const submitLabel = submit?.querySelector('span:first-child');
  const available = option.dataset.available === 'true';

  if (currentPrice) currentPrice.textContent = option.dataset.price || '';
  if (comparePrice) {
    comparePrice.textContent = option.dataset.compare || '';
    comparePrice.hidden = !option.dataset.compare;
  }
  if (saving) {
    saving.textContent = option.dataset.saving || '';
    saving.hidden = !option.dataset.saving;
  }
  if (submit) submit.disabled = !available;
  if (submitLabel) submitLabel.textContent = available ? 'Add to cart' : 'Sold out';
});
